import styled from 'styled-components';
import {
  EmptyState,
  EmptyStateTitle,
  IconBrowse,
} from '@spotify-internal/encore-web';
import { useGetProfileProtectionData } from '@hooks/useGetProfileProtectionData';
import { usePagination } from '@hooks/usePagination';
import { useProfileProtectionsCopy } from '@hooks/useProfileProtectionsCopy';
import { Loading } from '@components/shared/Loading';
import { ProfileProtectionsTable } from './ProfileProtectionsTable';

const StyledEmptyState = styled(EmptyState)`
  min-height: 400px;
`;

const PaginationContainer = styled.div`
  position: relative;
`;

export const ProfileProtections = () => {
  const { data, isLoading } = useGetProfileProtectionData();
  const { page, limit, renderPagination } = usePagination();
  const copy = useProfileProtectionsCopy();

  if (isLoading) {
    return <Loading />;
  }

  if (data.length === 0) {
    return (
      <StyledEmptyState
        icon={IconBrowse}
        variant="contextual"
        maxInlineSize="400px"
        iconColorSet="brightAccent"
      >
        <EmptyStateTitle>{copy.noReleasesFound}</EmptyStateTitle>
      </StyledEmptyState>
    );
  }

  const pagedData = data.slice((page - 1) * limit, page * limit);

  return (
    <>
      <ProfileProtectionsTable rows={pagedData} />
      <PaginationContainer>
        {renderPagination({
          totalResultRows: data.length,
          finalTotalResultIsKnown: true,
          customRowsPerPageText: copy.resultsPerPage,
        })}
      </PaginationContainer>
    </>
  );
};
